// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2WAQJ","label":"Section_label__brg3W","contentWrap":"Section_contentWrap__1TNuw","footer":"Section_footer__wsNqf","footerInner":"Section_footerInner__kX44t"};